/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2022, Zumper
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export type ListingIdAndBuildingIdTuple =
  | [listingId: number, buildingId: number]
  | [listingId: number, buildingId: null | undefined]
  | [listingId: null | undefined, buildingId: number]
  | [listingId: null | undefined, buildingId: null | undefined]

export const selectStream = (state: State | { stream?: undefined }) => state?.stream
export const selectStreamChannelIds = compose((stream) => stream?.channelIds, selectStream)

export const selectStreamChannelIdKey = (
  ...[listingId, buildingId]: ListingIdAndBuildingIdTuple
) => {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const key = `listingId=${listingId ?? undefined},buildingId=${buildingId ?? undefined}` as const
  if (key === 'listingId=undefined,buildingId=undefined') {
    return undefined
  }
  return key
}

export const selectStreamChannel = (state: State, ...args: ListingIdAndBuildingIdTuple) => {
  const key = selectStreamChannelIdKey(...args)
  const channelIds = selectStreamChannelIds(state)
  return key ? channelIds?.[key] : undefined
}

export const selectStreamChannelData = (state: State, ...args: ListingIdAndBuildingIdTuple) =>
  selectStreamChannel(state, ...args)?.data

export const selectStreamChannelId = (state: State, ...args: ListingIdAndBuildingIdTuple) =>
  selectStreamChannelData(state, ...args)?.streamChannelId
